import React from 'react';
import AboutTemplate from './AboutTemplate';
import { platformData } from './platformData';

const GVEPAbout = () => {
  return (
    <AboutTemplate
      {...platformData.gvep}
      platformKey="gvep"
    />
  );
};

export default GVEPAbout;
